import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  CaseNotes,
  ClientInformation,
  CommonUtility,
  DataService,
  DateUtility,
  MIN_CHAR_SEARCH_LENGTH,
  Role,
  ServerConstantsService,
  Task,INVALID_EMAIL,
  WpPerson,
  WpReferral, EligSummary
} from '../shared';
import * as $ from 'jquery';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ActivatedRoute, Router } from '@angular/router';
import { ProviderService } from '../provider-management/provider-management.service';
import { WpProvider } from '../shared/model/wp-provider.model';
import { Observable } from 'rxjs/Observable';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {
  CanComponentDeactivate,
  CanDeactivateGuardService
} from '../shared/modals/modal-popup/can-deactivate-gaurd.service';
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';
import { TaskAdditionalInfo } from '../shared/task-additional-info.model';
import { FormControl, FormGroup } from '@angular/forms'

@Component({
  selector: 'app-create-task',
  templateUrl: './create-task.component.html',
  styleUrls: ['./create-task.component.scss']
})
export class CreateTaskComponent implements OnInit, OnDestroy, CanComponentDeactivate {

  referralId = '';
  wpPersonId = '';
  sharedData: any;
  task: Task;
  taskPrev: Task;
  noteSize = 0;
  textSize = 0;
  notes: any = '';
  issueBeingReported: any = '';

  responseObject: Task;
  taskStatus: any[];
  taskTypes: any[];
  taskTypesCopy: any[];
  disableTaskTypes: any[];
  programs: any[];
  taskDueDates: any[];
  serverConstants: any;

  taskDueDatesMap: any;
  userActionNotificationsMap: any;
  valArray: any[];
  refData: any;
  isProviderDisable = true;
  suggestions: any = [];
  isNewTask = true;
  assignedTo: string;
  creationDate: any;
  pageTitle: string;
  available: any[];
  counties: any[];
  ariesCounties: any[];
  today: Date = new Date();
  disableTaskStatus = false;
  statusDate: any;
  taskDueDate: any;
  providers: any[] = [];
  otherTaskDueDate: Date;
  caseNotes: CaseNotes;
  isUniverse = false;
  ssnValue;
  showSsn: Boolean = true;
  ssnType = 'text';
  isChangeDetected;
  demographicChangeType='';
  isTaskSaved = false;
  isTaskClosed = false;
  complaintType= '';
  userSearch: string;
  suggestionsUser: any = [];
  elasticSuggestionsUser = new BehaviorSubject<any>(null);
  countiesArr: Array<any> = [];
  user: any;
  roles: Role[];
  isStateWorker = true;
  loaderFocus: Boolean = false;
  loaderFocusTaskType: Boolean = false;
  selected:Boolean = true;
  ServerConstants: any;
  providerSearch: string;
  elasticSuggestions = new BehaviorSubject<any>(null);
  results: any = [];
  newServiceProvider;
  serviceError:Boolean = false;
  zipcodeError: Boolean = false;
  contactCheck: Boolean = false;
  clientServiceCounty;
  countiesReverseJson;
  isRRTaskOpenInprogress;
  clientIfo: ClientInformation;
  userRole1: Boolean;
  userRole2: Boolean;
  isSysCoordinator: Boolean;
  newTemplate: Boolean;
  isProvider: Boolean;
  correctedFirstName='';
  correctedLastName='';
  correctedDob: any;
  correctedSsn='';
  incomeChangeType='';
  subTaskType='';
  otherType='';
  employerName='';
  newIncomeAmount=''; 
  startDate: any;
  salary='';
  frequency: string;
  frequencyList: any[];
  employmentStatus='';
  employmentStatusList: any[];  
  reasonForEmploymentTermination='';
  reasonForEmploymentTerminationList: any[];  
  employerContactPhone='';
  isSecondJob='';
  isSecondJobList: any[];
  employmentEndDate: any;
  incomeType;
  selectedIncomeType;
  incomeTypeList: any[];
  stateList: any[];
  resCountyList: any[];
  phoneTypeList: any[];
  earnedIncomeTypeList: any[];
  unearnedIncomeTypeList: any[];  
  createdBy;
  createdDt: any;
  lastModifiedBy;
  taskAdditionalInfo: TaskAdditionalInfo;
  contactChangeResidential: boolean;
  checkBoxErrorMessage: boolean;
  checkBoxEmailErrorMessage: boolean;
  contactChangeMailing: boolean;
  contactChangePhone: boolean;
  contactChangeEmail: boolean;
  contactChangeType='';
  copyResidentialAddress: boolean;
  residentialAddressLine1='';
  residentialAddressLine2='';
  residentialCity='';
  residentialState='';
  residentialZip='';
  residentialCounty='';
  mailingAddressLine1='';
  mailingAddressLine2='';
  mailingCity='';
  mailingState='';
  mailingZip='';
  phoneNumber='';
  phoneType='';
  email='';
  emailErrorEmailField: string = null;
  zipcodeErrorMessageField: string = null;
  mailingzipcodeErrorMessageField: string = null;
  EmployerContactErrorMessageField: string = null;
  emailErrorMessageField: string = null;
  invalidEmailFlag:Boolean;
  invalidSalaryFlag:Boolean;
  invalidIncomeFlag:Boolean;
  invalidSsnFlag:Boolean;
  invalidZipcodeFlag:Boolean;
  invalidMailingZipcodeFlag:Boolean;
  invalidEmployerContactFlag:Boolean;
  isCaseClosed:Boolean;
  isCasePending:Boolean;
  invalidDobFlag:Boolean;
  userRole: Array<any> = [];
  minDobDate: NgbDateStruct;
  maxDobDate: NgbDateStruct; 
  disableResCounty: Boolean = true;
  isEnrollmentOpen: Boolean = false;
  isEmploymentPlanOpen: Boolean = false;
  isComponentOpen: Boolean = false;
  skipValidation: Boolean = false;
  isDisabled: Boolean = false;
  enrollId;
  CaseClosureErrorMessageField: string = null;

  @ViewChild('taskTypeEl') taskTypeEl: ElementRef;
  @ViewChild('taskStatusEl') taskStatusEl: ElementRef;
  @ViewChild('county') county: ElementRef;
  @ViewChild('provider') provider: ElementRef;
  @ViewChild('countyDD') countyDD: ElementRef;
  @ViewChild('providerDD') providerDD: ElementRef;
  @ViewChild('notesEl') notesEl: ElementRef;
  @ViewChild('resetBtn') resetBtn: ElementRef;
  @ViewChild('saveBtn') saveBtn: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;  
  @ViewChild('correctedSsnField') correctedSsnField: ElementRef;
  @ViewChild('correctedZipField') correctedZipField: ElementRef;
  @ViewChild('salaryField') salaryField: ElementRef;
  @ViewChild('newIncomeAmountField') newIncomeAmountField: ElementRef;
  @ViewChild('emailField') emailField: ElementRef;
  @ViewChild('residentialCountyField') residentialCountyField: ElementRef;
  @ViewChild('labelText') labelText: ElementRef;
  contactField: string;
  
  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private data: ReferenceTableService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private dateUtil: DateUtility,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private router: Router,
    private providerService: ProviderService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('CRTSK') === undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    console.log('this.taskTypes === ' + this.taskTypes);
    this.dataService.globalAccess = true;
    this.sharedData = this.dataService.getSharedDataObject();
    this.isUniverse = this.sharedData.get('UNIVERSE_SEARCH');
    this.task = Object.assign({}, this.sharedData.get('task'));
    console.log('this.isUniverse - ' + this.isUniverse);
   //Code to validate Enrollment ,Employment,Component For case closure task--- start 
    if(this.task.taskType==="CC"){
    this.http.post<any>(this.serverConstants.COMMON_SERVER_API_URL + '/personsummary/personEnrollmentSummary',
      { 'referralId': Number(this.task.wpReferral.id), 'personId': Number(this.task.wpPerson.id) })
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res !== null || res !== undefined) { 
            const personEnrollmentSummary: any = res;
              if (personEnrollmentSummary.etEnrollment !== null) {
                this.enrollId=personEnrollmentSummary.etEnrollment.id;
                if (personEnrollmentSummary.etEnrollment.enrollmentEndDt === null) {
                  this.isEnrollmentOpen=true;
                 }
             } 
                   
          }
        },
        
        response => {

         
            
          },
        () => {
           //second method
           this.getEmploymentAndComponentDetails(this.enrollId);
        });
    }
    if (this.isUniverse === undefined) {
      this.isUniverse = false;
      this.isCaseClosed = false;
      this.isCasePending = false;
    } 
    
    if(this.isUniverse) {
      this.isCaseClosed = this.sharedData.get('isCaseClosed');
      this.isCasePending = this.sharedData.get('isCasePending');
    }
    this.ssnValue = this.sharedData.get('SSN_SEARCH');
    this.countiesArr = this.sharedData.get('userCounties');
    
    console.log('isCaseClosed - '+ this.isCaseClosed);
    console.log('isCasePending - '+ this.isCasePending);
    if (this.countiesArr === undefined) {
      this.countiesArr = JSON.parse(sessionStorage.getItem('userCounties'));
    }
    sessionStorage.setItem('userCounties', JSON.stringify(this.countiesArr));
    this.roles = this.sharedData.get('roles');
    this.setAssignedUserAccess();
    this.getRefTableData();
    this.getProviders();
    this.loadTaskData();
    if (this.isUniverse) {
      this.clientIfo = this.sharedData.get('UniverseClientInfo');
      this.getClientServiceCounty();
      this.validateTaskTypeExists('RR');
    }    

    console.log('Roles    === ' + this.roles[0].id);
    if(this.roles[0].id ===4){
      this.isSysCoordinator = true;
    }
    if(this.roles[0].id ===5){
      this.isProvider = true;
    }

    if(this.roles[0].id !==5){
      this.userRole2 = false;
      this.userRole1 = true;
    }
    else{
      this.userRole1 = false;
      this.userRole2 = true;
    }
    this.minDobDate = {
      month: this.today.getMonth() + 1,
      day: this.today.getDate(),
      year: this.today.getFullYear() - 100
    };

    this.maxDobDate = {
      month: this.today.getMonth() + 1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    };
       
    if(this.residentialState === 'AR') {
      this.disableResCounty=false;
      if(!this.residentialCountyField === undefined)
      this.residentialCountyField.nativeElement.disabled=false;
    } else{
      this.disableResCounty=true;
      this.residentialCounty='';
      if(!this.residentialCountyField === undefined)
      this.residentialCountyField.nativeElement.disabled=true;
    }
    
  }

  getEmploymentAndComponentDetails(enrollId){

    if(enrollId!==null){
    console.log("this.enrollId==="+enrollId);
    this.http.post<any>(this.serverConstants.SERVER_API_URL + '/employmentplan/latest',
    { 'etEnrollmentId': Number(enrollId)
    })
    .subscribe(
      data=> {
           if(data.hasOwnProperty('EmploymentPlanOpen')) {
            this.isEmploymentPlanOpen = data['EmploymentPlanOpen'];
            }
            if(data.hasOwnProperty('ComponentsOpen')) {
              this.isComponentOpen = data['ComponentsOpen'];
            }
            if(data.hasOwnProperty('skipValidation')) {
              this.skipValidation = data['skipValidation'];
            }

        console.log(" this.isEmploymentPlanOpen===="+ this.isEmploymentPlanOpen);
        console.log(" this.isComponentOpen===="+ this.isComponentOpen);    
       
      },
      response => {
            
        },
      () => {
         this.displayValidationMessage(this.isEnrollmentOpen,this.isEmploymentPlanOpen,this.isComponentOpen, this.skipValidation);
         
      });

    }
  }

  displayValidationMessage(EnrollmentOpen,EmploymentPlanOpen,ComponentOpen, skipValidation){

    if(skipValidation) {
      this.CaseClosureErrorMessageField=null;
      this.isDisabled=false;
    } else {
      if (EnrollmentOpen && EmploymentPlanOpen && ComponentOpen) {
        this.CaseClosureErrorMessageField="Please close the Enrollment, Employment Plan and Component prior to completing the case closure task.";
        this.isDisabled=true;
      }  else if (EnrollmentOpen && EmploymentPlanOpen && !ComponentOpen) {
        this.CaseClosureErrorMessageField="Please close the Enrollment and Employment Plan prior to completing the case closure task.";
        this.isDisabled=true;
      } else if (EnrollmentOpen && !EmploymentPlanOpen &&  ComponentOpen) {
        this.CaseClosureErrorMessageField="Please close the Enrollment and Component prior to completing the case closure task.";
        this.isDisabled=true;
      }
      else if (!EnrollmentOpen && EmploymentPlanOpen && ComponentOpen) {
        this.CaseClosureErrorMessageField="Please close the Employment Plan and Component prior to completing the case closure task.";
        this.isDisabled=true;
      } 
      else if (EnrollmentOpen && !EmploymentPlanOpen && !ComponentOpen) {
        this.CaseClosureErrorMessageField="Please close the Enrollment prior to completing the case closure task.";
        this.isDisabled=true;
      }
      else if (!EnrollmentOpen && EmploymentPlanOpen && !ComponentOpen) {
        this.CaseClosureErrorMessageField="Please close the Employment Plan prior to completing the case closure task.";
        this.isDisabled=true;
      }
      else if (!EnrollmentOpen && !EmploymentPlanOpen && ComponentOpen) {
        this.CaseClosureErrorMessageField="Please close the Component prior to completing the case closure task.";
        this.isDisabled=true;
      }
    }
    
    console.log(" this.CaseClosureErrorMessageField==="+ this.CaseClosureErrorMessageField);
    console.log("this.isDisabled==="+this.isDisabled);
  }

  validateDobDate(event){ 
    let elem: any = this || event;
    event.srcElement.valid=false;    
    const monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
  
    // Parse the date input to integers
    if(this.correctedDob !== undefined) {
      const month = this.correctedDob.month;
      const day = this.correctedDob.day;
      const year = this.correctedDob.year;
      const MIN_YEAR = this.minDobDate.year;
      const MAX_YEAR = this.maxDobDate.year;
  
      if(month !== undefined && day !== undefined && year !== undefined){
        // Make sure date is in range
        if (year < MIN_YEAR || year > MAX_YEAR || month === 0 || month > 12) {           
          this.invalidDobFlag = true; 
          console.log('Check year and month');
          return false;   
        }
        // Adjust for leap years
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
          monthLength[1] = 29;
        }
        // Check the range of the day
        if (!(day > 0 && day <= monthLength[month - 1])) {          
          this.invalidDobFlag = true;
          console.log('Check the date range');
          return false;      
        };

        this.invalidDobFlag = false;
        console.log('Valid Date');
        $("#field_correctedDob_errorMsgInvalidDt").remove(); 
        return true;
      }
      this.invalidDobFlag = true;
      
    } else{
      this.invalidDobFlag = true;     
    }      
    if(!this.invalidDobFlag)
        $("#field_correctedDob_errorMsgInvalidDt").remove(); 
    console.log('invalidDobFlag ' + this.invalidDobFlag);       
    return !this.invalidDobFlag;
  }

  setAssignedUserAccess() {
    this.isStateWorker = true;
    for (const role of this.roles) {
      if (role.id === 5) {
        this.isStateWorker = false;
        break;
      }
    }
  }

  loadTaskData() {
    if (this.sharedData.get('task')) {
      this.pageTitle = 'Edit Task';
      this.isNewTask = false;
      this.task = Object.assign({}, this.sharedData.get('task'));
      // this.loadUserForEditTask();
      this.getTask(this.task.id);

      console.log('====this.task.taskTyp ' + this.task.taskType);
      if(this.task.taskType === 'OS') {
        this.otherType='SS'; 
        this.task.taskType='OT'; 
        this.issueBeingReported=this.task.taskAdditionalInfo.issueReported;   
        this.textSize = this.issueBeingReported.length;    
      } else if(this.task.taskType === 'OP') {
        this.otherType='RU';    
        this.task.taskType='OT';          
      }
    } else {
      this.loadCreateTaskData();
      this.taskPrev = Object.assign({}, this.task);
    }
  }

  getTask (taskId) {
    this.http.post<any>(this.serverConstants.SERVER_API_URL + '/tasks/getTaskById', taskId).subscribe(
      (data: any) => {
        if (data == null || data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Task', this.userActionNotificationsMap.ERROR);
        } else {
          this.task = data;
          this.loadUserForEditTask();
        }
      },
      response => {
        this.notificationService.error('Task', 'Error while geting the task');
      },
      () => {
      });
  }

  loadUserForEditTask() {
    if (this.task.assignedUser === null || this.task.assignedUser === undefined) {
      this.loadEditTaskData();
    } else {
      this.http.post<any>(this.serverConstants.SERVER_API_URL + '/admin/user-mgmt/getUser', this.task.assignedUser).subscribe(
        (data: any) => {
          if (data == null || data.hasOwnProperty('errorCode')) {
            this.notificationService.error('Load Staff Management', this.userActionNotificationsMap.ERROR);
          } else {
            this.user = data;
            this.loadEditTaskData();
          }
        },
        response => {
          this.notificationService.error('User', 'Unable to get user information');
        },
        () => {
        });
    }
  }

  loadEditTaskData() {
    for (const type of this.disableTaskTypes) {
      if (type.value !== undefined) {
        this.taskTypes.push(type);
      }
    }

    if (this.task.taskDueDt != null) {
      this.taskDueDate = this.dateUtil.convertDateFromServer(this.task.taskDueDt);
    }

    if (this.task.createdDate != null) {
      this.creationDate = this.dateUtil.convertDateFromServer(this.task.createdDate.split('T')[0]);
    }

    this.disableTaskStatus = false;

    if (this.task.statusDt != null) {
      this.statusDate = this.dateUtil.convertDateFromServer(this.task.statusDt.split('T')[0]);
    } else {
      this.statusDate = this.dateUtil.convertDateFromServer(this.task.createdDate.split('T')[0]);
    }

    this.wpPersonId = this.sharedData.get('wpPersonId');

    this.task.assignedTo = this.task.assignedTo + '';

    if (this.user !== null && this.user !== undefined) {
      this.userSearch = this.user.firstName + ' ' + this.user.lastName;
    }

    if (this.task.taskStatus === 'CO') {
      this.isTaskClosed = true;
    }

    this.notes = this.task.notes;
    this.noteSize = this.notes.length;
    
    this.roles = this.sharedData.get('roles');
    console.log('Roles    === ' + this.roles[0].id);
    if(this.roles[0].id ===4){
      this.isSysCoordinator = true;
    }
    if(this.roles[0].id ===5){
      this.isProvider = true;
    }
    console.log('==== this.task.taskType ' + this.task.taskType + " === " + this.isProvider);

      if(this.task.taskType === 'OS') {
        this.otherType='SS';   
        this.task.taskType='OT'; 
        this.issueBeingReported=this.task.taskAdditionalInfo.issueReported; 
        this.textSize = this.issueBeingReported.length;
        this.newTemplate = true;     
      } else if(this.task.taskType === 'OP') {
        this.otherType='RU';  
        this.task.taskType='OT';  
        this.newTemplate = true;     
      }
      
    this.taskPrev = Object.assign({}, this.task);
  }

  loadCreateTaskData() {
    this.pageTitle = 'Create Task';
    this.isNewTask = true;

    const person: WpPerson = new WpPerson();
    person.id = parseInt(this.sharedData.get('wpPersonId'), 10);

    const referral: WpReferral = new WpReferral();
    referral.id = parseInt(this.sharedData.get('referralId'), 10);

    this.wpPersonId = this.sharedData.get('wpPersonId');

    this.task = new Task();
    this.task.wpPerson = person;
    this.task.wpReferral = referral;
    this.task.programCd = 'FS';

    const todayStr = (this.today.getFullYear() + '/' + (this.today.getMonth() + 1) + '/' + this.today.getDate());
    this.creationDate = this.dateUtil.convertDateFromServer(todayStr);

    this.task.taskStatus = 'OP';
    this.disableTaskStatus = true;

    if (this.isUniverse) {
      this.task.taskType = 'RR';
      this.task.assignedToInd = 'C';
    }
    this.changeTaskDueDate(this.task.taskType);
    this.subTaskType='';
    this.resetDemographicChanges();
    this.resetContactChanges();
    this.resetEmpIncomeChanges();
    this.resetOtherType();   
    this.resetComplaintTask();  

  }

  restrictSpecial(event){
    if((/[<>{}-]/.test(event.key))){
      event.returnValue = false;
      return;
     }
      event.returnValue = true;
  }

  onClick() {
    if (this.ssnType === 'password') {
      this.ssnType = 'text';
      this.showSsn = true;
    } else {
      this.ssnType = 'password';
      this.showSsn = false;
    }
  }
  
  getProviders() {
    this.providerService.findAllActiveProviders().subscribe(
      (res) => {
        if (res == null || res.hasOwnProperty('errorCode')) {
          this.notificationService.error('Providers', this.userActionNotificationsMap.ERROR);
        } else {
          // this.providers.push({ 'name': 'Pick an option', 'value': undefined });
          const providersList: WpProvider[] = res;

          if (providersList != null) {
            for (const p of providersList) {
              this.providers.push({ 'name': p.providerName, 'value': p.id + '' });
            }
            this.providers.sort(this.commonUtil.sortObjectsByStringProperty('name'));
          }
          this.providers.unshift({ value: undefined, name: 'Pick an Option' });
        }
      }, (res: HttpErrorResponse) => {
        this.notificationService.error('Providers', this.userActionNotificationsMap.ERROR);
      }, () => {
      }
    );
  }

  validateTaskTypeExists(taskType) {
    if (taskType === null || taskType === undefined) {
      return;
    }

    let personId;
    let referralId;
    if (this.isUniverse && this.clientIfo !== undefined && this.clientIfo.CLIENTID > 0) {
      personId = this.clientIfo.CLIENTID;
      referralId = 0;
    } else {
      personId = this.task.wpPerson.id;
      referralId = this.task.wpReferral.id;

    }


    this.http.post<any>(this.serverConstants.SERVER_API_URL + '/tasks/latestTaskExists',
      { taskType: taskType, personId: personId, referralId: referralId }).subscribe(
        (val) => {
          if (val == null || val.hasOwnProperty('errorCode')) {
            this.notificationService.error('Task', this.userActionNotificationsMap.ERROR);
          } else {
            const taskExists = val;

            if (taskExists) {
              this.isRRTaskOpenInprogress = taskExists;
              if (!this.isUniverse) {
                this.notificationService.warn('Task', ' Task Already exists.');
              }
            }
          }
        },
        response => {
          this.notificationService.error('Task', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }

  dataChanges() {
    this.isChangeDetected = true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  }


  getClientServiceCounty() {

    this.http.get<EligSummary[]>(this.serverConstants.SERVER_API_URL + '/SNAPWorks/GetEligibilitySummary/' + this.ssnValue).subscribe(
      (data: EligSummary[]) => {
        if (data !== null && data !== undefined && data.length > 0) {
          const countyName = data[0].COUNTY;
          if (countyName !== undefined) {

            console.log('Aries county :' + countyName);
            this.clientServiceCounty = this.countiesReverseJson[countyName];
            if (this.clientServiceCounty !== undefined) {
              this.task.assignedTo = this.clientServiceCounty;
            } else {
              this.notificationService.error('Referral Task Creation',
                'Unable to find county code in RT Table for ' + countyName);
            }
          } else {
            this.notificationService.error('Referral Task Creation', 'Client service county not found in Eligibility System');
          }
        } else {
          this.notificationService.error('Referral Task Creation', 'Client service county not found in Eligibility System');
          this.clientServiceCounty = undefined;
        }
      },
      response => {
        this.notificationService.error('Referral Task Creation', 'Client service county not found in Eligibility System');
      },
      () => {
      });
  }


  saveTask() {
    if(this.selected !== true){
      this.userSearch = "";
      this.notificationService.warn('Task', 'Invalid User');
    }
    this.isChangeDetected = false;
    this.modalPopupService.setChangeDetected(false);
    if (this.isUniverse && !this.isStateWorker) {

      if (!this.isRRTaskOpenInprogress) {
        // const person = new Person(200021, 'Test', 'Test', this.ssnValue, '2018/05/05',
        //   'Address', '12345', 'MM', 200021, 1, 1, 1, 3, 'Y', 'V');
        // this.savePerson(person);
        if (this.clientIfo !== undefined && this.clientIfo.CLIENTID > 0 && this.clientServiceCounty > 0) {

          const person = new Person(this.clientIfo.CLIENTID, this.clientIfo.FIRST_NAME, this.clientIfo.LAST_NAME,
            this.ssnValue, this.dateUtil.formatDate(this.clientIfo.DOB_DT),
            this.clientIfo.MAILING_ADDR_CITY, this.clientIfo.MAILING_ADDR_ZIP, 'MM',
            this.clientIfo.CLIENTID, 1, 1, 1, this.clientServiceCounty, 'Y', 'V',this.dataService.getSharedDataObject().get("providerId"));
          this.savePerson(person);

        } else {
          this.notificationService.error('Referral Task Creation', 'Client Summary Information not found in Eligibility System');
        }
      } else {
        this.notificationService.warn('Referral Task Creation', ' Task Already exists.');
      }

    } else {
      this.saveTaskObject();
    }
  }
  save(){
    if(this.task.taskType === 'ET'){
      let ssnValue = this.sharedData.get('SSN_SEARCH');
      this.http.get(this.serverConstants.SERVER_API_URL + '/SNAPWorks/GetClientWorkParticipation/'
      + ssnValue).subscribe((data)=>{
        if(!data["errorCode"]){
          if(data[0].WORK_PART == "5E"){
            this.saveTask();
          }
          else{
            this.notificationService.warn('The Work Participation Code must be 5E in Eligibility System for Task Closure.');
          }
        }
        else{
          this.notificationService.warn('Unable to Check Work Participation Code, SSN not found.');
        }
      })
    }
    if(this.task.taskType === 'CT'){
      
      if (!this.contactChangeResidential && !this.contactChangeMailing && !this.contactChangePhone && !this.contactChangeEmail ) {
        this.checkBoxErrorMessage=true;    
       }
       else if (this.contactChangeEmail && (this.email==null || this.email =='' || this.email==undefined || this.email.length < 1)) {
       this.checkBoxEmailErrorMessage=true;   

     }
    //  else if(this.contactChangeResidential || this.contactChangeMailing || this.contactChangePhone || (this.contactChangeEmail &&  (this.email!==null || this.email !=='' || this.email!==undefined))){
    //   console.log("inside else 2");
    //   this.saveTask();
      
    //  }
    else{
      this.saveTask();
    }
    }
    else{
     this.saveTask();
     
    }
  }
  
  focusEmail(e: KeyboardEvent) {
    this.loaderFocus = true;
  }

  focusLabelText(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.labelText.nativeElement.focus(), 0);
    }
  }

  saveTaskObject() {    
    this.isChangeDetected = false;
    // this.modalPopupService.setChangeDetected(false);

    console.log('this.otherType === ' + this.otherType);
    console.log('this.otherTaskDueDate === ' + this.otherTaskDueDate);
    console.log('this.taskDueDate === ' + this.taskDueDate);

    /*if(this.otherType === 'DP' || this.otherType === 'PC' || this.otherType === 'PD' 
    || this.otherType === 'DS' || this.otherType === 'AP' || this.otherType === 'OP'
    || this.otherType === 'OS') {
      this.task.taskDueDt = this.dateUtil.convertDateForServer(this.otherTaskDueDate);
    } else{*/
      this.task.taskDueDt = this.dateUtil.convertDateForServer(this.taskDueDate);
    //}  
    
    this.task.createdDate = null;
    this.task.notes = this.notes;
    this.task.subTaskType = this.subTaskType;
    this.task.taskAdditionalInfo = new TaskAdditionalInfo();
    this.task.taskAdditionalInfo.correctedFirstName = this.correctedFirstName;
    this.task.taskAdditionalInfo.correctedLastName = this.correctedLastName;
    this.task.taskAdditionalInfo.correctedDob = this.dateUtil.convertDateForServer(this.correctedDob);
    this.task.taskAdditionalInfo.correctedSsn = this.correctedSsn;
    this.task.taskAdditionalInfo.subTaskType = this.subTaskType;
    this.task.taskAdditionalInfo.employerName = this.employerName;
    if (this.newIncomeAmount === '' || this.newIncomeAmount === null || this.newIncomeAmount === "null") {
      this.task.taskAdditionalInfo.newIncomeAmount = '0';
    }
    else {
      this.task.taskAdditionalInfo.newIncomeAmount = this.newIncomeAmount;
    }   
    this.task.taskAdditionalInfo.employmentStartDate = this.dateUtil.convertDateForServer(this.startDate);

    console.log('this.salary ======= ' + this.salary);
    if (this.salary === '' || this.salary === null || this.salary === "null") {
      this.task.taskAdditionalInfo.salary = '0';
    }
    else {
      this.task.taskAdditionalInfo.salary = this.salary;
    }      
    this.task.taskAdditionalInfo.frequency = this.frequency;
    this.task.taskAdditionalInfo.employmentStatus = this.employmentStatus;
    this.task.taskAdditionalInfo.employerContactPhone = this.employerContactPhone;
   
    if(this.isSecondJob === "Yes") {
      this.task.taskAdditionalInfo.isSecondJob = 'Y';
    } else if(this.isSecondJob === "No") {
      this.task.taskAdditionalInfo.isSecondJob = 'N';
    }    
    this.task.taskAdditionalInfo.employmentEndDate = this.dateUtil.convertDateForServer(this.employmentEndDate);
    this.task.taskAdditionalInfo.terminationReason = this.reasonForEmploymentTermination;
    this.task.taskAdditionalInfo.incomeChangeType = this.incomeChangeType;
    this.task.taskAdditionalInfo.incomeType = this.selectedIncomeType;
    this.task.taskAdditionalInfo.createdBy = this.createdBy;
    this.task.taskAdditionalInfo.createdDt = this.dateUtil.convertDateForServer(this.createdDt);
    this.task.taskAdditionalInfo.lastModifiedBy = this.lastModifiedBy;
    
    this.task.taskAdditionalInfo.residentialAddressLine1 = this.residentialAddressLine1.split(',').join(' ');
    this.task.taskAdditionalInfo.residentialAddressLine2 = this.residentialAddressLine2.split(',').join(' ');
    this.task.taskAdditionalInfo.residentialCity = this.residentialCity;
    this.task.taskAdditionalInfo.residentialState = this.residentialState;
    this.task.taskAdditionalInfo.residentialZip = this.residentialZip;
    this.task.taskAdditionalInfo.residentialCounty = this.residentialCounty;
    this.task.taskAdditionalInfo.mailingAddressLine1 = this.mailingAddressLine1.split(',').join(' ');
    this.task.taskAdditionalInfo.mailingAddressLine2 = this.mailingAddressLine2.split(',').join(' ');
    this.task.taskAdditionalInfo.mailingCity = this.mailingCity;
    this.task.taskAdditionalInfo.mailingState = this.mailingState;
    this.task.taskAdditionalInfo.mailingZip = this.mailingZip;
    this.task.taskAdditionalInfo.phoneNumber = this.phoneNumber;
    this.task.taskAdditionalInfo.phoneType = this.phoneType;
    this.task.taskAdditionalInfo.email = this.email;
    if(this.copyResidentialAddress)
      this.task.taskAdditionalInfo.copyResidentialAddress = 'Yes';
    else
      this.task.taskAdditionalInfo.copyResidentialAddress = 'No';

    this.task.taskAdditionalInfo.contactChangeType='';
    if(this.contactChangeEmail){
      if(this.task.taskAdditionalInfo.contactChangeType !== '') {
        this.task.taskAdditionalInfo.contactChangeType = this.task.taskAdditionalInfo.contactChangeType + ', '
      }
      this.task.taskAdditionalInfo.contactChangeType = 'Email';
    }      
    if(this.contactChangeMailing){
      if(this.task.taskAdditionalInfo.contactChangeType !== '') {
        this.task.taskAdditionalInfo.contactChangeType = this.task.taskAdditionalInfo.contactChangeType + ', '
      }
      this.task.taskAdditionalInfo.contactChangeType = this.task.taskAdditionalInfo.contactChangeType + 'Mailing';
    }
      
    if(this.contactChangePhone){
      if(this.task.taskAdditionalInfo.contactChangeType !== '') {
        this.task.taskAdditionalInfo.contactChangeType = this.task.taskAdditionalInfo.contactChangeType + ', '
      }
      this.task.taskAdditionalInfo.contactChangeType = this.task.taskAdditionalInfo.contactChangeType + 'Phone';
    }
      
    if(this.contactChangeResidential){
      if(this.task.taskAdditionalInfo.contactChangeType !== '') {
        this.task.taskAdditionalInfo.contactChangeType = this.task.taskAdditionalInfo.contactChangeType + ', '
      }
      this.task.taskAdditionalInfo.contactChangeType = this.task.taskAdditionalInfo.contactChangeType + 'Residential';
    }      

    this.task.taskAdditionalInfo.residentialState = this.residentialState;

    this.task.otherType = this.otherType;
    this.task.taskAdditionalInfo.otherType = this.otherType;
    this.task.taskAdditionalInfo.issueReported = this.issueBeingReported;
    this.task.taskAdditionalInfo.complaintType = this.complaintType;
    this.task.taskAdditionalInfo.notes = this.notes;
    
    
    if (this.task.taskType === 'AP') {
      this.notificationService.error('Task', 'Appointment task cannot be manually closed.');
    } else {
      this.http.post<Task>(this.serverConstants.SERVER_API_URL + '/tasks/save', this.task).subscribe(
        (val) => {
          if (val == null || val.hasOwnProperty('errorCode')) {
            if (this.task.taskType === 'CT' || this.task.taskType === 'DC' || this.task.taskType === 'EI' 
            || this.otherType === 'DP' || this.otherType === 'PC' || this.otherType === 'PD' 
            || this.otherType === 'DS' || this.otherType === 'AP' || this.task.taskType === 'CO' 
            || this.task.taskType === 'WR' || this.task.taskType === 'RR') {                   
              this.notificationService.error('Task','Unable to send task to the eligibility system; system will retry later.');              
            } else {
              this.notificationService.error('Task', this.userActionNotificationsMap.ERROR);
            }
            
            setTimeout(() => this.taskTypeEl.nativeElement.focus(), 0);
            this.taskTypeEl.nativeElement.click();
          } else {
            this.task = val;

            if (this.task.id != null) {


              if (this.task.taskDueDt != null) {
                this.taskDueDate = this.dateUtil.convertDateFromServer(this.task.taskDueDt);
              }

              if (this.task.createdDate != null) {
                this.creationDate = this.dateUtil.convertDateFromServer(this.task.createdDate);
              }

              if (this.task.statusDt != null) {
                this.statusDate = this.dateUtil.convertDateFromServer(this.task.statusDt);
              }

              this.task.assignedTo = this.task.assignedTo + '';

              // In case needs to update task
              this.dataService.addValueToSharedDataMap('task', this.task);
              this.responseObject = Object.assign({}, this.task);

              if (this.task.taskType === 'CT' || this.task.taskType === 'DC' || this.task.taskType === 'EI'
                  || this.otherType === 'DP' || this.otherType === 'PC' || this.otherType === 'PD' 
                  || this.otherType === 'DS' || this.otherType === 'AP' || this.task.taskType === 'CO'
                  || this.task.taskType === 'WR' || this.task.taskType === 'RR') {
                this.notificationService.success('Task successfully sent to the eligibility system for processing.', this.userActionNotificationsMap.UPDATE);
              } else {
                this.notificationService.success('Task saved successfully', this.userActionNotificationsMap.UPDATE);
              }
              
              if (this.task.taskType === 'GD' ||  this.task.taskType === 'DU') {
                this.notificationService.warn('Task', 'This is a non-actionable task and will not be sent to ARIES.');
              }
              if (this.task.taskType === 'AC' || this.task.taskType === 'EC' || this.task.taskType === 'TC') {
                this.createCaseNote();
              }

              this.isTaskSaved = true;

              setTimeout(() => this.taskTypeEl.nativeElement.focus(), 0);
              this.taskTypeEl.nativeElement.click();

            }
          }
        },
        response => {
          if (this.task.taskType === 'CT' || this.task.taskType === 'DC' || this.task.taskType === 'EI'
              || this.otherType === 'DP' || this.otherType === 'PC' || this.otherType === 'PD' 
              || this.otherType === 'DS' || this.otherType === 'AP' || this.task.taskType === 'CO'
              || this.task.taskType === 'WR' || this.task.taskType === 'RR') {                      
            this.notificationService.error('Task','Unable to send task to the eligibility system; system will retry later.');              
          } else {
            this.notificationService.error('Task', this.userActionNotificationsMap.ERROR);
          }          
          setTimeout(() => this.headerText.nativeElement.focus(), 0);
          this.headerText.nativeElement.click();
        },
        () => {

        });
    }
  }


  savePerson(person) {
    this.http.post<WpPerson>(this.serverConstants.COMMON_SERVER_API_URL + '/persondata/save-universe', person)
      .subscribe(
        (res: any) => {
          if (res.hasOwnProperty('errorCode')) {
            this.notificationService.error('Client', this.userActionNotificationsMap.ERROR + ' Could not save the client information.');
          } else {
            if (res !== undefined && res.result !== undefined) {
              if (res.result === 'Client exist already and open enrollment records found' || res.result === 'Invalid request') {
                this.notificationService.error('Client', res.result);
              } else {
                this.notificationService.success('Client', res.result);
                this.task.wpPerson.id = res.personId;
                this.task.wpReferral.id = 0;
                this.saveTaskObject();
              }
            }
          }
        },
        (response) => {
          this.notificationService.error('Client', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }


  createCaseNote() {

    this.caseNotes = new CaseNotes();
    this.caseNotes.createdDt = new Date();
    this.caseNotes.createdDt = this.dateUtil.convertObjectDateForServer(this.caseNotes.createdDt);
    this.caseNotes.notes = this.notes;
    this.caseNotes.personId = Number(this.wpPersonId);

    if (this.task.taskType === 'AC') {
      this.caseNotes.typeCd = 'AN'; // Address note
    } else if (this.task.taskType === 'EC') {
      this.caseNotes.typeCd = 'EN';  // EmploymentNotes
    } else if (this.task.taskType === 'TC') {
      this.caseNotes.typeCd = 'CC';   // Client Contact
    }


    this.http.post<CaseNotes>(this.serverConstants.SERVER_API_URL + '/casenotes/save', this.caseNotes)
      .subscribe(
        (res: CaseNotes) => {
          if (res.hasOwnProperty('errorCode')) {
            this.notificationService.error('Case Notes', this.userActionNotificationsMap.ERROR);
          } else {
            this.caseNotes = res;
            if (this.caseNotes.id !== undefined || this.caseNotes.id != null) {
              this.notificationService.success('Case Notes saved successfully', this.userActionNotificationsMap.UPDATE);
            }
          }
        },
        (response) => {
          this.notificationService.error('Case Notes', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }

  getRefTableData() {
    this.programs = this.data.getValueFromSharedDataMap('PROGRAMS');
    this.taskStatus = this.data.getValueFromSharedDataMap('TASKSTATUS');
    this.counties = this.data.getValueFromSharedDataMap('COUNTIES');
    this.ariesCounties = this.data.getValueFromSharedDataMap('ariesCounties');
    this.countiesReverseJson = this.commonUtil.createReverseNativeMapFromList(this.counties);
    this.taskDueDates = this.data.getValueFromSharedDataMap('TASKDUEDATES');
    this.taskDueDatesMap = this.commonUtil.createMapFromList(this.taskDueDates);
    this.taskTypesCopy = this.data.getValueFromSharedDataMap('TASKTYPES');
    this.disableTaskTypes = this.data.getValueFromSharedDataMap('DISABLETASKTYPES');
    const disableTaskTypesMap = this.commonUtil.createMapFromList(this.disableTaskTypes);
    this.frequencyList = this.data.getValueFromSharedDataMap('ARIES_Income_Frequency_Type');
    this.employmentStatusList = this.data.getValueFromSharedDataMap('Employment_Status_Code');    
    this.reasonForEmploymentTerminationList = this.data.getValueFromSharedDataMap('Income_Termination_Reason_Type');
    this.resCountyList = this.data.getValueFromSharedDataMap('ResidenceCounties'); 
    this.stateList = this.data.getValueFromSharedDataMap('STATE'); 

    this.earnedIncomeTypeList = this.data.getValueFromSharedDataMap('ARIES_Earned_Income_Type');
    this.unearnedIncomeTypeList = this.data.getValueFromSharedDataMap('ARIES_Unearned_Income_Type');
      
    this.phoneTypeList = this.data.getValueFromSharedDataMap('Phone_Type'); 
    this.incomeTypeList = [];    
    for (const type of this.earnedIncomeTypeList) {
      if (type.value !== undefined) {
        this.incomeTypeList.push(type);
      }
    }

    for (const type of this.unearnedIncomeTypeList) {
      if (type.value !== undefined) {
        this.incomeTypeList.push(type);
      }
    }    
    
    this.taskTypes = [];
    let array1=[];
    let array2=[];
    
    
    disableTaskTypesMap.forEach((item, index) => {     
        disableTaskTypesMap.delete('GD');
    });
    
    if (this.sharedData.get('task')) {
      this.taskTypesCopy.map((item, index) => {
        if (!disableTaskTypesMap.has(item.value)
        || item.value === undefined) {
          this.taskTypes.push(item);
        }
      });
    }
    else{
      this.taskTypesCopy.map((item, index) => {        
        if (!disableTaskTypesMap.has(item.value)
          || item.value === undefined) {           
          if(item.value === undefined || item.value.charAt(0) === 'O'){
              array1.push(item);
              array2.push(item);
            }
            else if(item.value === 'ET'){
              console.log("ET Task");
            }
            else if(item.value === 'RR'){
              if(this.isUniverse){
                array2.push(item);
                array1.push(item);
              }
            } 
          else if(item.value === 'GD' ){
              array2.push(item);
              array1.push(item);
            }        
          else if(item.value === 'DC' || item.value === 'EI' || item.value === 'CT' || item.value === 'CO' ){            
            array2.push(item);            
          }else if(item.value.charAt(0)=== 'C'){
            array1.push(item);
            array1.sort();
          } 
           else{
            if(item.value !== 'GQ'){
              array2.push(item);
            }
             
             array2.sort();
           }
        }
      });
      if(this.roles[0].id !==5){
        this.taskTypes = array1;
      }
      else{
        this.taskTypes = array2;
      }
    }
    

    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(
      this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
  }

  convertCode(myMap, code) {
    if (myMap !== undefined) {
      return myMap.get(code);
    }
  }

  onQuickTextChanged(event) {
    this.noteSize = this.notes.length;
  }

  onQuickIssueTextChanged(event) {
    this.textSize = this.issueBeingReported.length;
  }

  onChange(event) {
    this.notes = '';
    this.subTaskType=null;
    this.contactChangeResidential=false;
    this.contactChangeEmail=false;
    this.contactChangePhone=false;
    this.contactChangeMailing=false;
    this.loaderFocusTaskType = true;    
    this.resetDemographicChanges();
    this.resetContactChanges();
    this.resetEmpIncomeChanges();
    this.resetOtherType();   
    this.resetComplaintTask();  
    event.srcElement.blur();
    event.preventDefault();
    console.log('this.taskType ' + this.task.taskType + " " + this.isProvider);
    this.checkBoxErrorMessage=false;
    this.checkBoxEmailErrorMessage=false;
    this.emailErrorEmailField="";
    this.zipcodeErrorMessageField="";
    this.invalidZipcodeFlag = false;
    this.invalidEmployerContactFlag = false;
    this.zipcodeErrorMessageField='';
    this.invalidMailingZipcodeFlag = false;
    this.mailingzipcodeErrorMessageField='';
    this.invalidEmailFlag = false;
    this.emailErrorMessageField = '';
  }

  tasktypeNoFocus(e) {
    if (e.keyCode === 9 && !e.shiftKey) {
      this.loaderFocusTaskType = false;
    }
  }

  changeTaskDueDate(val) {
    for (const taskDD of this.taskDueDates) {
      if (taskDD.value === val) {
        const taskDueDt = new Date();
        taskDueDt.setDate(taskDueDt.getDate() + Number(taskDD.name));
        const dueDtMonth = (taskDueDt.getMonth() + 1) >= 10 ? '' + (taskDueDt.getMonth() + 1) : '0' + (taskDueDt.getMonth() + 1);
        const taskDueDtStr = (taskDueDt.getFullYear() + '/' + dueDtMonth + '/' + taskDueDt.getDate());      
        this.taskDueDate = this.dateUtil.convertDateFromServer(taskDueDtStr);
        this.otherTaskDueDate = this.dateUtil.convertDateFromServer(taskDueDtStr);
        break;
      }
    }
  }

  setTaskDueDateForOtherTasks() {
    if(this.otherType === 'DP' || this.otherType === 'PC' || this.otherType === 'PD' 
    || this.otherType === 'DS' || this.otherType === 'AP') {
      this.otherTaskDueDate = new Date();
      
      this.otherTaskDueDate.setDate( this.otherTaskDueDate.getDate() + 10);
      const dueDtMonth = (this.otherTaskDueDate.getMonth() + 1) >= 10 ? '' + (this.otherTaskDueDate.getMonth() + 1) : '0' + (this.otherTaskDueDate.getMonth() + 1);
      const taskDueDtStr = (this.otherTaskDueDate.getFullYear() + '/' + dueDtMonth + '/' + this.otherTaskDueDate.getDate());
  
      this.taskDueDate = this.dateUtil.convertDateFromServer(taskDueDtStr);
     
    } else if(this.otherType === 'RU') {
      this.changeTaskDueDate('OP');
    } else if(this.otherType === 'SS') {
      this.changeTaskDueDate('OS');
    } else{
      this.changeTaskDueDate('OT');
    }  
    console.log("this.taskDueDate====" + this.taskDueDate) ;
    this.issueBeingReported='';
    this.textSize=0;
  }

  setAvailable() {
    this.task.assignedTo = null;
    this.task.assignedUser = null;
    if (this.isNewTask) {
      if (this.task.assignedToInd === 'C') {
        this.available = this.counties;
      } else {
        this.available = this.providers;
      }
    }
  }

  setSubTastType(event: any) {
    this.demographicChangeType = event.target.value;
    this.subTaskType = event.target.value;
    console.log("Sub Task Type =====" + this.subTaskType);
    this.invalidEmployerContactFlag=false;
    if(this.subTaskType === 'NC' || this.subTaskType === 'SC' || this.subTaskType === 'DC') {      
      this.resetDemographicChanges();
    } else if(this.subTaskType === 'NE' || this.subTaskType === 'TE' || this.subTaskType === 'OI') {
      this.resetEmpIncomeChanges();
    }    
  }

  setIncomeChangeType(event: any) {
    this.incomeChangeType = event.target.value;    
  }  

  ngOnDestroy() {
    this.dataService.removeValueFromSharedDataMap('task');
  }

  reset() {
    this.loadTaskData();
  }

  focusTaskType(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.taskTypeEl.nativeElement.focus(), 0);
    }
  }

  focusTaskStatus(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.taskStatusEl.nativeElement.focus(), 0);
    }
  }

  focusCounty(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.county.nativeElement.focus(), 0);
    }
  }

  focusProvider(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.provider.nativeElement.focus(), 0);
    }
  }

  focusNext(e: KeyboardEvent, indicator) {
    if (e.keyCode === 9 && !e.shiftKey) {
      if (indicator === 'C') {
        if (this.countyDD) {
          setTimeout(() => this.countyDD.nativeElement.focus(), 0);
        }
      } else if (indicator === 'P') {
        if (this.providerDD) {
          setTimeout(() => this.providerDD.nativeElement.focus(), 0);
        }
      } else {
        if (this.task.taskType === 'AC' || this.task.taskType === 'EC' || this.task.taskType === 'TC' || this.task.taskType === 'OT'|| this.task.taskType === 'OS'|| this.task.taskType === 'OP') {
          setTimeout(() => this.notesEl.nativeElement.focus(), 0);
        } else {
          setTimeout(() => this.resetBtn.nativeElement.focus(), 0);
        }
      }
    }
  }

  focusTasktype(e: KeyboardEvent) {
    this.loaderFocusTaskType = true;
  }

  focusAssignedTo(e: KeyboardEvent) {
    this.loaderFocus = true;
    this.loaderFocusTaskType = false;
  }

  focusNext2(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      if (this.task.taskType === 'AC' || this.task.taskType === 'EC' || this.task.taskType === 'TC' || this.task.taskType === 'OT' || this.task.taskType === 'OS' || this.task.taskType === 'OP') {
        setTimeout(() => this.notesEl.nativeElement.focus(), 0);
      } else {
        setTimeout(() => this.resetBtn.nativeElement.focus(), 0);
      }
    }
  }

  focusReset(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.resetBtn.nativeElement.focus(), 0);
    }
  }

  focusHeader(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  getUserSuggestions(event) {
    this.selected = false;
    this.suggestionsUser = [];
    if (this.userSearch === null) {
      return;
    }
    if (this.userSearch.length >= MIN_CHAR_SEARCH_LENGTH) {
      event.srcElement.blur();
      event.preventDefault();
      this.elasticUserSearch(this.elasticSuggestionsUser);
      this.elasticSuggestionsUser.subscribe((value) => {
        this.suggestionsUser = value;
      });
    } else {
      this.suggestionsUser = [];
    }
  }

  elasticUserSearch(results) {
    const fullName = this.userSearch;
    let providerId = null;
    const serviceCounties = [];

    if (this.task.assignedToInd === 'P') {
      /*providerId = ;
      if (this.countiesArr !== undefined && this.countiesArr !== null) {
        for (const countyArr of this.countiesArr) {
          serviceCounties.push(countyArr.id.serviceCounty);
        }
      }*/
      return;
    } else if (this.task.assignedToInd === 'C') {
      providerId = null;
      serviceCounties.push(this.task.assignedTo);
    }

    this.http.post(this.serverConstants.SERVER_API_URL + '/es-user/search/',
     { fullName: fullName, providerId: providerId, serviceCounties: serviceCounties }).subscribe(
      (val) => {
        results.next(val);
      },
      response => {
        this.notificationService.error('Users', this.userActionNotificationsMap.ERROR);
        results.next(null);
      }
    );
  }

  autoCompleteUserClick(user: EsUser) {
    this.selected = true;
    this.userSearch = user.firstName + ' ' + user.lastName;
    this.task.assignedUser = user.id;
    this.suggestionsUser = [];
    this.elasticSuggestionsUser.next(null);
  }

  autoCompleteUserKeydown(e: KeyboardEvent, user: EsUser) {
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.userSearch = user.firstName + ' ' + user.lastName;
      this.task.assignedUser = user.id;
      this.suggestionsUser = [];
      this.elasticSuggestionsUser.next(null);
    } else {
      return;
    }
  }

  changeAssignedTo() {
    this.task.assignedUser = null;
    this.userSearch = null;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  numberFloatOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  alphaCharsOnly(event): boolean {    
    const charCode = (event.which) ? event.which : event.keyCode;
    
    if ((charCode >= 97 && charCode  <= 122) || (charCode >= 65 && charCode  <= 90) || charCode == 39 || charCode == 32) {
      return true;
    }
    return false;

  }

  alphaCharsNumbersLimitedSpecialCharsOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    console.log('charCode ==== ' + charCode);
    if(charCode == 44 || charCode == 45 || charCode == 32 || charCode == 39 || charCode == 46 || charCode == 38) {
      console.log('true 1');
      return true;
    }
      
    if ((charCode >= 97 && charCode  <= 122) || (charCode >= 65 && charCode  <= 90) || (charCode >= 48 && charCode <= 57)) {        
      console.log('true 2');
      return true;
    } else if (charCode > 31) {
      console.log('false 1');
      return false;
    }
    console.log('false 2');
    return false;

  }

  alphaCharsNumbersOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    console.log('charCode ==== ' + charCode + (charCode == 44));
    /*if(charCode == 44)
      return false;*/
    if ((charCode >= 97 && charCode  <= 122) || (charCode >= 65 && charCode  <= 90) || charCode == 39 ||
         (charCode >= 48 || charCode <= 57)) {        
      return true;
    } else if (charCode > 31) {
      return false;
    }
    return false;

  }

  isSalaryInRange(val, min, max) {
    console.log('isInRange ==== '+ val);
    const valFloat = parseFloat(val);
    console.log(valFloat);
    const result = ( !isNaN(valFloat) && (valFloat <= max) && (valFloat >= min) );
    if(result !== true) {
      this.invalidSalaryFlag = true;
      this.salaryField.nativeElement.classList.remove("ng-valid");
      this.salaryField.nativeElement.classList.add("ng-invalid");
      return false;
    }
    else {
      this.invalidSalaryFlag = false;
      this.salaryField.nativeElement.classList.remove("ng-invalid");
      this.salaryField.nativeElement.classList.add("ng-valid");
      return true;
    }
  }

  isIncomeInRange(val, min, max) {
    console.log('isIncomeInRange ==== '+ val);
    const valFloat = parseFloat(val);
    console.log(valFloat);
    const result = ( !isNaN(valFloat) && (valFloat <= max) && (valFloat >= min) );
    if(result !== true) {
      this.invalidIncomeFlag = true;
      this.newIncomeAmountField.nativeElement.classList.remove("ng-valid");
      this.newIncomeAmountField.nativeElement.classList.add("ng-invalid");
      return false;
    }
    else {
      this.invalidIncomeFlag = false;
      this.newIncomeAmountField.nativeElement.classList.remove("ng-invalid");
      this.newIncomeAmountField.nativeElement.classList.add("ng-valid");
      return true;
    }
  }

  onSelectedSecondJobChange(val:String){
    console.log("onSelectedSecondJobChange ==== " + val + " === " + this.isSecondJob);
  }
  updateMailingAddress(){    
    if(this.copyResidentialAddress) {
      console.log("inside copyResidentialAddress");
      this.mailingAddressLine1 = this.residentialAddressLine1;
      this.mailingAddressLine2 = this.residentialAddressLine2;
      this.mailingCity = this.residentialCity;
      this.mailingState = this.residentialState;
      this.mailingZip = this.residentialZip;
    } else {
      this.mailingAddressLine1 = '';
      this.mailingAddressLine2 = '';
      this.mailingCity = '';
      this.mailingState = '';
      this.mailingZip = '';
    }
  }

  resetResidentialAddress(){   
    this.copyResidentialAddress = false; 
    if(!this.contactChangeResidential) {      
      this.residentialAddressLine1 = '';
      this.residentialAddressLine2 = '';
      this.residentialCity = '';
      this.residentialState = '';
      this.residentialZip = '';
      this.residentialCounty = '';      
      this.disableResCounty=true;  
      this.invalidZipcodeFlag = false;
      this.zipcodeErrorMessageField='';
      this.invalidMailingZipcodeFlag = false;
      this.invalidEmailFlag = false;
      this.emailErrorMessageField = '';
      this.mailingzipcodeErrorMessageField='';
      if(!this.residentialCountyField === undefined)
      this.residentialCountyField.nativeElement.disabled=true;
    
    }
  }

  resetMailingAddress(){
    this.copyResidentialAddress = false; 
    if(!this.contactChangeMailing) {      
      this.mailingAddressLine1 = '';
      this.mailingAddressLine2 = '';
      this.mailingCity = '';
      this.mailingState = '';
      this.mailingZip = '';
      this.invalidZipcodeFlag = false;
      this.zipcodeErrorMessageField='';
      this.invalidMailingZipcodeFlag = false;
      this.invalidEmailFlag = false;
      this.emailErrorMessageField = '';
      this.mailingzipcodeErrorMessageField='';
      
    }
    
  }

  resetPhoneDetails(){    
    if(!this.contactChangePhone) {      
      this.phoneNumber = '';
      this.phoneType = '';  
      this.invalidZipcodeFlag = false;   
      this.zipcodeErrorMessageField=''; 
      this.invalidMailingZipcodeFlag = false;
      this.mailingzipcodeErrorMessageField='';
      this.invalidEmailFlag = false;
      this.emailErrorMessageField = '';
    }
    
  }

  resetEmailDetails(){    
    if(!this.contactChangeEmail) {      
      this.email = '';  
      this.invalidZipcodeFlag = false;  
      this.zipcodeErrorMessageField=''; 
      this.invalidMailingZipcodeFlag = false;
      this.mailingzipcodeErrorMessageField='';  
      this.invalidEmailFlag = false;
      this.emailErrorMessageField = '';    
    }
    
  }


  resetDemographicChanges(){    
    this.correctedFirstName = '';      
    this.correctedLastName = '';  
    this.correctedSsn = '';  
    this.correctedDob = '';  
    this.invalidSsnFlag = false;
    this.invalidDobFlag = false;
    this.ssnType='text';
    this.showSsn=true;
  }

  resetContactChanges(){     
    this.resetResidentialAddress();
    this.resetMailingAddress();
    this.resetPhoneDetails();
    this.resetEmailDetails();   
    this.copyResidentialAddress = false;
    this.invalidZipcodeFlag = false;
    this.zipcodeErrorMessageField='';
    this.invalidMailingZipcodeFlag = false;
    this.mailingzipcodeErrorMessageField='';
    this.invalidEmailFlag = false;
    this.emailErrorMessageField = '';
  }

  resetEmpIncomeChanges(){    
    this.employerContactPhone = '';  
    this.reasonForEmploymentTermination = '';  
    this.employmentEndDate = '';  
    this.employerName= '';  
    this.isSecondJob= '';  
    this.employerContactPhone= '';  
    this.employmentStatus= '';
    this.salary= '';
    this.invalidSalaryFlag = false;         
    this.startDate= null; 
    this.incomeChangeType ='';
    this.incomeType= '';
    this.selectedIncomeType= '';
    this.newIncomeAmount= '';
    this.invalidIncomeFlag = false;   
    this.frequency= '';
    this.invalidEmployerContactFlag = false;
    this.EmployerContactErrorMessageField='';

  }

  resetOtherType(){    
    this.otherType='';  
    this.issueBeingReported='';
    this.textSize=0;
    this.newTemplate=false;
  }

  resetComplaintTask(){    
    this.complaintType='';  
    this.notes='';
    this.noteSize=0;
  }
  populateResCounty() {
    console.log('this.residentialState ' + this.residentialState);
    if(this.residentialState === 'AR') {
      this.disableResCounty=false;
      if(!this.residentialCountyField === undefined)
      this.residentialCountyField.nativeElement.disabled=false;
    } else{
      this.disableResCounty=true;
      this.residentialCounty='';
      if(!this.residentialCountyField === undefined)
      this.residentialCountyField.nativeElement.disabled=true;
    }
    
  }

  // validateEmail() {
   
  //   const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //   console.log("email=="+this.email);
  //   if (this.email !== null && this.email !== undefined && this.email !== "") {
  //     if (!regExp.test(String(this.email).toLowerCase())) {
  //       this.emailErrorEmailField = INVALID_EMAIL;
  //       return false;
  //     }
  //    }
  //     else {
  //       this.emailErrorEmailField = "";
  //       return false;
        
  //     }
  //   this.emailErrorEmailField = null;
  //     return true;
  // }

  validateContactChange() {
     if (this.contactChangeResidential || this.contactChangeMailing || this.contactChangePhone || this.contactChangeEmail ) {
       this.contactCheck=true;  
     }
    else {
        this.contactField = "Required Field.";
        this.contactCheck=false;
 
      }
      return this.contactCheck;
  }

  isValidSSN(str) {  
    const regex = /^(?!(000|666|9))(\d{3}-?(?!(00))\d{2}-?(?!(0000))\d{4})$/;             
    console.log("isValidSSN ===================" + str + " " + regex.test(str));
    // Return true if the str
    // matched the ReGex
    if (regex.test(str)) {   
        this.invalidSsnFlag = false;
        this.ssnType='password';
        this.showSsn=false;
        this.correctedSsnField.nativeElement.classList.remove('ng-invalid');
        this.correctedSsnField.nativeElement.classList.add('ng-valid');       
        return true;
    }
    else {
        this.invalidSsnFlag = true;
        this.ssnType='text';
        this.showSsn=true;
        this.correctedSsnField.nativeElement.classList.remove('ng-valid');
        this.correctedSsnField.nativeElement.classList.add('ng-invalid');
        return false;
    }
    
}
validateZipCode(str) 
{
  console.log("validateZipCode========");
  console.log("str==="+str);
  if (/^\d{5}(-\d{4})?$/.test(str) || str==="" || str===undefined) 
  {
    this.invalidZipcodeFlag = false;
   this.zipcodeErrorMessageField = "";
    console.log("zipcodeErrorMessageField==="+this.zipcodeErrorMessageField);
    return true;

  } else {
    this.invalidZipcodeFlag = true;
    this.zipcodeErrorMessageField = "Zip Code requires 5 numeric characters ";
    console.log("zipcodeErrorMessageField error==="+this.zipcodeErrorMessageField);
    return false;

  }
  
} 
validateMailingZipCode(str) 
{
  console.log("validateMailingZipCode========");
  console.log("str==="+str);
  if (/^\d{5}(-\d{4})?$/.test(str) || str==="" || str===undefined) 
  {
    this.invalidMailingZipcodeFlag = false;
    this.mailingzipcodeErrorMessageField = "";
    return true;
  } else {
    this.invalidMailingZipcodeFlag = true;
    this.mailingzipcodeErrorMessageField = "Zip Code requires 5 numeric characters ";
    console.log("mailingzipcodeErrorMessageField error==="+this.mailingzipcodeErrorMessageField);
    return false;
  }
} 

validateEmailAddress(str) 
{
  console.log("validateEmailAddress========");
  //const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  console.log("str==="+str);
  if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(str) || str==="" || str===undefined) 
  {
    this.invalidEmailFlag = false;
   this.emailErrorMessageField = "";
    console.log("emailErrorMessageField==="+this.emailErrorMessageField);
    return true;

  } else {
    this.invalidEmailFlag = true;
    this.emailErrorMessageField = "Invalid Email";
    console.log("emailErrorMessageField error==="+this.emailErrorMessageField);
    return false;

  }
  
} 

validateEmployerContactInput(str) 
{
  console.log("validateEmployerContactInput========");
  console.log("str==="+str);
  if (/^[1-9][0-9]{9}$/.test(str) || str==="" || str===undefined) 
  {
    this.invalidEmployerContactFlag = false;
    this.EmployerContactErrorMessageField = "";
    console.log("EmployerContactErrorMessageField==="+this.EmployerContactErrorMessageField);
    return true;

  } else {
    this.invalidEmployerContactFlag = true;
    this.EmployerContactErrorMessageField = "Phone Number requires 10 numeric characters";
    console.log("EmployerContactErrorMessageField error==="+this.zipcodeErrorMessageField);
    return false;

  }
  
} 

getSuggestions(event) {
  this.selected = false;
  this.loaderFocus = true;
  this.suggestions = [];
  this.elasticSuggestions.next(null);
  if (this.incomeType.length >= MIN_CHAR_SEARCH_LENGTH) {
    event.srcElement.blur();
    event.preventDefault();
    this.elasticSearch(this.incomeType, this.elasticSuggestions);
    this.elasticSuggestions.subscribe((value) => {
      this.suggestions = [];
      if (value !== null && value.length > 0) {
        value.forEach(element => {
          this.suggestions.push(element);
        });
        this.suggestions.sort(this.commonUtil.sortObjectsByStringProperty('name'));
        this.isProviderDisable = true;

      } else {
        this.isProviderDisable = false;
      }
    });
  } else {
    this.suggestions = [];
  }
}

autoCompleteResultClick(result) {
  this.selected = true;
  this.serviceError = false;
  console.log(result.code + " == " + result.name + " == " + result.id);
  this.incomeType = result.name;
  this.selectIncomeType();
  this.suggestions = [];
  this.elasticSuggestions.next(null);
}

elasticSearch(searchQuery, results) {
  this.http.post(this.serverConstants.SERVER_API_URL + '/static/incomeTypes/', {text: searchQuery}).subscribe(
    (val: any[]) => {
      this.valArray = val;      
      results.next(val);
    },
    response => {
      this.notificationService.error('Create Task', this.userActionNotificationsMap.ERROR);
      results.next(null);
    }
  );
}

selectIncomeType(){  

  for (const type of this.incomeTypeList) {
    if (type.value !== undefined && type.name === this.incomeType) {     
     this.selectedIncomeType=type.value;
     break;
    }
  }
}

}

class Request {
  constructor(
    public task: Task,
    public person?: Person

  ) { }
}
class Person {
  constructor(
    public id: number,
    public firstName: string,
    public lastName: string,
    public ssn: string,
    public dobDt: any,
    public addrCity: string,
    public addrZip5: string,
    public addressTypeCd: string,
    public ieClientId: any,
    public addrCounty: any,
    public residentialCounty: any,
    public budgetUnitId: number,
    public serviceCounty: number,
    public snapEligibility: string,
    public operationType: string,
    public sufxName:number
  ) { }
}

class EsUser {
  constructor(
    public id: any,
    public firstName?: any,
    public lastName?: any,
    public userName?: any,
    public fullName?: any,
    public serviceCounties?: any,
    public providerId?: any,
    public roleId?: any,
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/task/create-task.component.ts